var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"msg"},[_vm._v(_vm._s(_vm.apiStatus.msg))]),_vm._v(" "),_c('div',{staticClass:"home"},[_c('a',{on:{"click":_vm.toIndex}},[_vm._v("返回首页")]),_c('br'),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20146dea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error/index.vue
// module id = null
// module chunks = 